import { GiftResponse } from "../dto/response/customer";
import { GiftModal } from "../model/customer";

export function transformGift({ given: given_list, received: received_list }: GiftResponse): GiftModal {
  return {
    givenList: given_list.map((given) => ({
      id: given.id,
      title: given.gift_info.title,
      deliveryDate: given.delivery_date,
      recipient: {
        firstName: given.receiver.first_name,
        lastName: given.receiver.last_name,
        email: given.receiver.email,
      },
      status: given.status,
      redeemedEmail: given.redeemer_email,
    })),
    receivedList: received_list.map((received) => ({
      id: received.id,
      title: received.gift_info.title,
      redeemDate: received.redeemed_at,
      subscriptionStartDate: received.subscription_start_date,
      subscriptionEndDate: received.subscription_end_date,
      giver: {
        firstName: received.giver.first_name,
        lastName: received.giver.last_name,
        email: received.giver.email,
      },
      status: received.status,
      redeemedEmail: received.redeemer_email,
    })),
  };
}
